'use client';
import { useState, useEffect } from 'react';
import useBreakpoint from '@/hooks/useBreakpoint';
import { AtButton, AtText } from '../atoms';

// Use control + g to show a grid visualizer in dev
export const GridVisualizer = () => {
  const [enabled, setEnabled] = useState<boolean>(false);
  const [showBp, setShowBp] = useState<boolean>(false);

  const bp: string = useBreakpoint();

  useEffect(() => {
    const handleKeyPress = (ev: KeyboardEvent) => {
      if (ev.ctrlKey && ev.key === 'g') {
        ev.preventDefault();
        setEnabled(!enabled);
      }
    };
    document.addEventListener('keydown', handleKeyPress);

    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [enabled]);

  let cols: number;
  if (bp === 'xs' || bp === 'sm') {
    cols = 1;
  } else if (bp === 'md') {
    cols = 6;
  } else {
    cols = 12;
  }

  return (
    <>
      {enabled && (
        <>
          {showBp ? (
            <div className="absolute right-0 top-0 flex flex-row items-center justify-center gap-4 bg-black/20 p-4 text-white">
              <AtText>Current Breakpoint: {bp}</AtText>
              <AtButton onClick={() => setShowBp(!showBp)}>Close</AtButton>
            </div>
          ) : (
            <div className="absolute right-0 top-0 flex flex-row items-center justify-center gap-4 bg-black/20 p-4 text-white">
              <AtButton onClick={() => setShowBp(!showBp)}>Open BP</AtButton>
            </div>
          )}
          <div className="pointer-events-none fixed top-0 z-[100] h-screen w-screen overflow-hidden">
            <div className="container m-auto min-h-full">
              <ul className="grid min-h-screen grid-cols-1 gap-1 md:grid-cols-6 lg:grid-cols-12">
                {Array.from(Array(cols), (_e, i) => {
                  return (
                    <li key={i} className="h-screen bg-red-500/20 text-center">
                      {i + 1}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </>
      )}
    </>
  );
};
